<!-- eslint-disable prettier/prettier -->
<ng-container *transloco="let t">
  <section
    class="checkout-order-summary"
    [class.popsy-card]="!isCheckout"
    [class.compact]="compact">
    <!-- Products from Products API -->
    <div class="header">
      @if (isCheckout) {
        <span class="fixed-space-8" aria-hidden="true"></span>
      }

      <strong class="title">{{ t('title_order_summary') }}</strong>
      <span class="fixed-space-16" aria-hidden="true"></span>
    </div>
    @if ((products$ | async) && deliveryOrders && !deliveryProducts) {
      <div [class.mobile]="mobileMode" role="list">
        @for (
          product of products$ | async;
          track trackByItem(pos, product);
          let pos = $index
        ) {
          <app-checkout-order-summary-item
            [item]="product"
            [quantity]="getProductQuantity(product?.id || '')"
            [insurance]="getProductInsurance(product?.id || '')"
            [loading]="loading"
            [mobileMode]="mobileMode"></app-checkout-order-summary-item>
          @if (pos + 1 < (deliveryOrders?.length || 0)) {
            <span class="fixed-space-16" aria-hidden="true"></span>
            <span class="line" aria-hidden="true"></span>
            <span class="fixed-space-16" aria-hidden="true"></span>
          }
        }
      </div>
    }
    <!-- Products from Delivery -->
    @if (deliveryProducts) {
      <div
        class="checkout-order-summary delivery-products"
        [class.mobile]="mobileMode"
        role="list">
        @for (
          product of deliveryProducts;
          track trackByItem(pos, product);
          let pos = $index
        ) {
          <app-checkout-order-summary-item
            [item]="product"
            [quantity]="product.quantity"
            [insurance]="getProductInsurance(product?.id || '')"
            [loading]="loading"
            [mobileMode]="mobileMode"></app-checkout-order-summary-item>
          @if (pos + 1 < (deliveryProducts?.length || 0)) {
            <span class="fixed-space-16" aria-hidden="true"></span>
            <span class="line" aria-hidden="true"></span>
            <span class="fixed-space-16" aria-hidden="true"></span>
          }
        }
      </div>
    }

    @if (isCheckout || (isProtected && protectionPrice)) {
      <span class="line" aria-hidden="true"></span>
      <span class="fixed-space-16" aria-hidden="true"></span>
    }

    @if (isProtected && protectionPrice) {
      <div class="row delivery-price">
        @if (language === 'en') {
          <strong class="label">Popsy Protection </strong>
        } @else {
          <strong class="label">حماية بوبسي</strong>
        }
        <span class="fixed-space-8" aria-hidden="true"></span>

        <p class="price">{{ protectionPrice | amount }}</p>
      </div>
      <span class="fixed-space-4" aria-hidden="true"></span>
    }

    @if (isCheckout) {
      @if (displayDeliveryPrice) {
        <div class="row delivery-price">
          <strong class="label">{{ t('label_delivery_price') }}</strong>
          <span class="fixed-space-8" aria-hidden="true"></span>
          @if ((displayDeliveryPrice?.amount || 0) <= 0) {
            <div class="flex-row flex">
              <span class="small crossed">{{ deliveryPriceFallback() | amount }}</span>
              <span class="fixed-space-8" aria-hidden="true"></span>
              <p class="price free">{{ t('label_free') }}</p>
            </div>
          }
          @if ((displayDeliveryPrice?.amount || 0) > 0) {
            <p class="price">{{ displayDeliveryPrice | amount }}</p>
          }
        </div>
      }
      @if (discount?.amount || (gotDiscountAfterLocked$ | async)) {
        <span class="fixed-space-8" aria-hidden="true"></span>
        <div class="row delivery-fee">
          <strong class="label">{{ t('label_discount') }}</strong>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <p class="price">{{ discountCodePrice() | amount }}</p>
        </div>
      }
      <span class="fixed-space-16" aria-hidden="true"></span>
      @if (gotDiscountAfterLocked$ | async) {
        <div class="row total" [class.mobile]="mobileMode">
          <strong class="label">{{ t('label_estimated_price_total') }}</strong>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <p class="price">
            {{ discount?.currency }}
            {{ (displayTotalPrice?.amount || 0) - (discount?.amount || 0) }}
          </p>
        </div>
      }
      @if (!(gotDiscountAfterLocked$ | async)) {
        <div class="row total" [class.mobile]="mobileMode">
          <strong class="label">{{ t('label_estimated_price_total') }}</strong>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <p class="price">{{ displayTotalPrice | amount }}</p>
        </div>
      }

      @if (!hideInstallmentOptions) {
        <span class="fixed-space-32" aria-hidden="true"></span>
        <app-checkout-installment-options
          [country]="productCountry"
          [price]="displayTotalPrice"
          [showAll]="alwaysShowTamaraTabbyPromos"></app-checkout-installment-options>
      }

      <span class="fixed-space-32" aria-hidden="true"></span>

      <!--  <span class="fixed-space-32" aria-hidden="true"></span>
      @if (showTabbyPromo$ | async) {
        <popsy-tabby-promo
          [amount]="displayTotalPrice?.amount"
          [currency]="displayTotalPrice?.currency"
          source="cart"></popsy-tabby-promo>
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      @if (showTamaraPromo$ | async) {
        <popsy-tamara-summary
          [productId]=""
          [amount]="displayTotalPrice?.amount"
          [currency]="displayTotalPrice?.currency"
          [country]="productCountry"
          [mobileMode]="mobileMode"
          source="cart"></popsy-tamara-summary>
        <span class="fixed-space-16" aria-hidden="true"></span>
      }

      @if (showBaseetaPromo$ | async) {
        <popsy-baseeta-promo
          [amount]="displayTotalPrice?.amount"
          [currency]="displayTotalPrice?.currency"
          [country]="productCountry"
          source="checkout"></popsy-baseeta-promo>
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      @if (showQuaraPromo$ | async) {
        <popsy-quara-promo
          [amount]="displayTotalPrice?.amount"
          [currency]="displayTotalPrice?.currency"
          [country]="productCountry"
          source="cart"></popsy-quara-promo>
        <span class="fixed-space-16" aria-hidden="true"></span>
      } -->
    }
  </section>
</ng-container>
